const SearchResultsReposition = function () {
  function SearchResultsReposition() {
    if ($('#search-results-container').length > 0) {
      this.bindFacetToggle();
      this.bindScroll();
    } else {
      this.unBindScroll();
    }
  }

  SearchResultsReposition.prototype.bindFacetToggle = function () {
    const self = this;
    $(document).off(
      'click',
      '.lp-filter-list .facet-text, .lp-filter-buttons .btn, .clear-all, .slider .slider-handle, .slider .slider-track, .lp-filter-body .form-control'
    );
    $(document).on(
      'click',
      '.lp-filter-list .facet-text, .lp-filter-buttons .btn, .clear-all, .slider .slider-handle, .slider .slider-track, .lp-filter-body .form-control',
      function () {
        self.reposition();
      }
    );
  };

  SearchResultsReposition.prototype.reposition = function () {
    this.initialDistanceFromTop = $(window).scrollTop();
    if ($('#search-cb-banner').length > 0) {
      this.searchBannerHeight = $('#search-cb-banner').outerHeight(true);
    } else {
      this.searchBannerHeight = 0;
    }
    if (this.initialDistanceFromTop > this.searchBannerHeight + 16) {
      this.headerHeight = $('.lp-header').outerHeight(true);
      this.searchHeaderHeight = $('#js-search-heading').outerHeight(true);
      this.resultsAreaWidth = $('#search-results-container').width();
      $('#search-results-container').css({ width: this.resultsAreaWidth });
      $('#js-search-heading').css({ position: 'fixed', top: this.headerHeight + 15 });
      $('#search-results-container').css({
        position: 'fixed',
        top: this.headerHeight + this.searchHeaderHeight + 15
      });
      $('footer').css({ opacity: '0' });
      $('#search-heading-row').css({
        'padding-top': this.initialDistanceFromTop - this.searchBannerHeight - 20
      });
      $('#search-results-container').addClass('repositioned');
      $('#search-results-container').addClass('positioning');
      setTimeout(function () {
        $('#search-results-container').removeClass('positioning');
      }, 1000);
    }
    this.lastScrollTop = 0;
  };

  SearchResultsReposition.prototype.onScroll = function () {
    if (
      $('#search-results-container').hasClass('repositioned') &&
      !$('#search-results-container').hasClass('positioning')
    ) {
      const newDistanceFromTop = $(window).scrollTop();
      if (
        newDistanceFromTop < this.lastScrollTop &&
        newDistanceFromTop < this.initialDistanceFromTop
      ) {
        // scroll up
        $('#js-search-heading').css({ position: 'fixed', top: this.headerHeight + 15 });
        $('#search-results-container').css({
          position: 'fixed',
          top: this.headerHeight + this.searchHeaderHeight + 15
        });
        $('footer').css({ opacity: '0' });
        $('#search-heading-row').css({
          'padding-top': newDistanceFromTop - this.searchBannerHeight - 20
        });
      } else {
        // scroll down
        $('#js-search-heading').css({ position: 'relative', top: '0' });
        $('#search-results-container').css({ position: 'relative', top: '0' });
        $('footer').css({ opacity: '1' });
      }
      if (newDistanceFromTop < this.searchBannerHeight + 16) {
        $('#search-heading-row').css({ 'padding-top': '0' });
        $('#js-search-heading').css({ position: 'relative', top: '0' });
        $('#search-results-container').css({ position: 'relative', top: '0' });
        $('footer').css({ opacity: '0' });
        $('#search-results-container').removeClass('repositioned');
      }
      this.lastScrollTop = newDistanceFromTop;
    }
  };

  SearchResultsReposition.prototype.bindScroll = function () {
    const self = this;
    return window.addEventListener(
      'scroll',
      function () {
        return this.onScroll();
      }.bind(self)
    );
  };

  SearchResultsReposition.prototype.unBindScroll = function () {
    const self = this;
    window.removeEventListener(
      'scroll',
      function () {
        return this.onScroll();
      }.bind(self)
    );
  };

  return SearchResultsReposition;
};

export default SearchResultsReposition;
